export default "__VITE_ASSET__6d01d280__"